import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import CalendarIcon from '../../../../assets/icons/calendar_icon.svg';
import ChevronLeft from '../../../../assets/icons/chevron_left_gray_14.svg';
import ChevronDown from '../../../../assets/icons/chevron_down_small_gray.svg';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    row-gap: 8px;
    grid-auto-rows: max-content;

    .react-datepicker {
        border: none;
        border-radius: 1px;
    }

    .react-datepicker__month-container {
        display: flex;
        flex-direction: column;
        border: none;
        z-index: 1;
    }

    .react-datepicker__header {
        border-radius: 1px 1px 0 0;
        background-color: #F2F2F2;
        padding-top: 18px;
        margin: 0;
        border: none;
    }

    .react-datepicker__month {
        margin: 0;
        padding: 8px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 2;
    }

    .react-datepicker__current-month {
        display: none;
    }

    .react-datepicker__day-names {
        margin-top: 12px;
        margin-bottom: 8px;
        line-height: normal;

        .react-datepicker__day-name {
            line-height: 16px;
            color: #63666A;
        }
    }

    .react-datepicker__day {
        margin: 2px 5px;
    }

    .react-datepicker__day--outside-month {
        color: #AAAAAA;
    }

    .react-datepicker__triangle {
        z-index: 10;
        position: absolute;
        left: 50%;

        &::before {
            display: none;
        }
    }

    .react-datepicker-popper {
        z-index: 100;
    }

    .react-datepicker-popper[data-placement^="bottom"] {
        margin-top: 14px;

        .react-datepicker__triangle {
            border-bottom-color: #F2F2F2;
            border-width: 8px;
        }
    }

    .react-datepicker-popper[data-placement^="top"] {
        margin-bottom: 14px;
    }

    .react-datepicker__navigation--previous, .react-datepicker__navigation--next {
        top: 20px;
        width: 14px;
        height: 14px;
        background-repeat: no-repeat;
        background-position: center right;
        border: none;
    }

    .react-datepicker__navigation--previous {
        left: 15px;
        background-image: url(${ChevronLeft});
    }

    .react-datepicker__navigation--next {
        right: 15px;
        background-image: url(${ChevronLeft});
        transform: rotate(180deg);
    }

    .react-datepicker__header__dropdown--scroll {
        display: flex;
        justify-content: space-evenly;
        padding: 0 48px;
    }

    .react-datepicker__year-option--selected {
        display: none;
    }

    .react-datepicker__month-dropdown, .react-datepicker__year-dropdown  {
        top: 100%;
        z-index: 4;
        max-height: 176px;
        border: none;
        background: ${colors.WHITE};
        padding: 8px 0px 8px 4px;
        margin: 0;
        margin-top: 14px;
        width: max-content;
        filter: drop-shadow(0px 8px 12px rgba(0, 0, 0, 0.1));
        left: -24px;
        border-radius: 1px;
        position: absolute;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            width: 18px;
        }

        &::-webkit-scrollbar-thumb {
            box-shadow: inset 0 0 20px 20px #D9D9D6;
            border: solid 6px transparent;
            border-radius: 999px;
        }

        &::after {
            content: '';
            position: absolute;
            margin-top: -3px;
            top: 0;
            left: 50%;
            margin-left: -6px;
            border-width: 6px;
            border-style: solid;
            border-color: transparent transparent white transparent;
        }
    }

    .react-datepicker__year-dropdown {
        left: -25%;
    }

    .react-datepicker__month-option, .react-datepicker__year-option {
        padding: 4px 8px;
        margin: 0;
        text-align: left;
        color: #63666A;

        &.--selected_month {
            color: ${colors.BLACK};
            background-color: #F2F2F2;      
        }
        
        &:hover {
            background-color: #F2F2F2;
            color: ${colors.BLACK};
        }
    }

    .react-datepicker__year-option {
        &:first-of-type, &:last-of-type{
            padding: 2px 0;
            display: flex;
        }
    }

    .react-datepicker__month-option--selected {
        display: none;
    }

    .react-datepicker__year-option--selected_year {
        color: ${colors.BLACK};
        background-color: #F2F2F2; 
    }

    .react-datepicker__month-dropdown-container--scroll, .react-datepicker__year-dropdown-container--scroll {
        margin: 0;
        display: flex;
        position: relative;
    }

    .react-datepicker__month-read-view, .react-datepicker__year-read-view {
        display: flex;
        border: none;
        align-items: center;
        visibility: visible !important;
    }

    .react-datepicker__navigation--years-upcoming, .react-datepicker__navigation--years-previous  {
        height: 7px;
        border: none;
        background-image: url(${ChevronDown});
        background-repeat: no-repeat;
        background-position: center center;
        transform: rotate(180deg);
        top: 0;
    }

    .react-datepicker__navigation--years-previous {
        transform: rotate(0deg);
    }

    .react-datepicker__month-read-view--down-arrow, .react-datepicker__year-read-view--down-arrow {
        top: 0;
        margin: 0;
        margin-left: 8px;
        width: 10px;
        height: 7px;
        border: none;
        background-image: url(${ChevronDown});
        background-repeat: no-repeat;
        background-position: center center;

        &::before {
            content: none;
        }

        order: 2;
    }

    .react-datepicker__month-read-view--selected-month {
        order: 1;
    }

    .react-datepicker__navigation-icon--previous {
        display: none;
    }

    .react-datepicker__navigation-icon--next {
        display: none;
    }

    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow {
        transform: none;
        margin-top: 5px;
    }
`;

export const Label = styled.label`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
`;

export const Optional = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
    color: #63666A;
`;

export const Input = styled.input`
    background-image: url(${CalendarIcon});
    background-repeat: no-repeat;
    background-position: calc(100% - 16px);
    width: 100%;
    padding: 12px 16px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    border: 1px solid #63666A;
    border-radius: 1px;

    &:focus {
        outline-color: #FFDFD0;
        outline-width: 3px;
        outline-offset: 2px;
        border-color: #D9D9D6;
    }

    &:hover:not(:focus) {
        border-color: ${colors.BLACK};
        cursor: pointer;
    }
`;

export const Error = styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #D44333;
`;
